'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideOverlay = exports.showOverlay = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('components/International/handlers.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var overlayActionEnd = function overlayActionEnd(action, resolve) {
  $(_Dom2.default.overlay).one('transitionend', function () {
    if (action === 'show' && $(_Dom2.default.overlay).is('.is-active')) {
      resolve();
    } else if (action === 'hide' && !$(_Dom2.default.overlay).is('.is-active')) {
      resolve();
    }
  });
};

var showOverlay = exports.showOverlay = function showOverlay() {
  return new Promise(function (resolve) {
    overlayActionEnd('show', resolve);
    $(_Dom2.default.overlay).addClass('is-active');
  });
};

var hideOverlay = exports.hideOverlay = function hideOverlay() {
  return new Promise(function (resolve) {
    overlayActionEnd('hide', resolve);
    $(_Dom2.default.overlay).removeClass('is-active');
    if ($(_Dom2.default.intModal).length > 0) {
      (0, _handlers.closeProductModal)();
    }
    if ($('[data-modal].is-active').length > 0) {
      $('[data-modal].is-active').removeClass('is-active');
    }
  });
};